import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'
import { useState } from 'react'
import type { UserWithMeta } from '~/@biz_account/useUser/types'
import { AddBankAccountDialog } from './AddBankAccountDialog'
import { Button } from '~/shadcn/ui/button/button'

type Props = {
  user: UserWithMeta
  onAccountAdded: () => void
}

function AddBankAccount({ user, onAccountAdded }: Props) {
  const [isAddBankAccountDialogOpen, setIsAddBankAccountDialogOpen] =
    useState(false)

  const buttonActionLabel =
    user?.profile?.bankAccounts?.length != null &&
    user?.profile?.bankAccounts?.length > 0
      ? 'Pridať ďalší bankový účet'
      : 'Pridať bankový účet'

  return (
    <div>
      <Button
        variant="outline"
        size="adaptive"
        className="w-full md:w-auto gap-2"
        onClick={() => setIsAddBankAccountDialogOpen(true)}>
        <GraphIcon />
        {buttonActionLabel}
      </Button>
      {isAddBankAccountDialogOpen && (
        <AddBankAccountDialog
          onClose={() => setIsAddBankAccountDialogOpen(false)}
          onSuccess={() => {
            setIsAddBankAccountDialogOpen(false)
            onAccountAdded()
          }}
        />
      )}
    </div>
  )
}

export { AddBankAccount }
